import classnames from 'classnames';
import isNil from 'lodash/isNil';
import { bool, number, string } from 'prop-types';
import React from 'react';
import { Label } from 'reactstrap';

import CurrencyFormat from '../CurrencyFormat';
import InfoTooltip from '../Tooltip/InfoTooltip';

const THRESHOLD = 20;

function OnsiteAverageDailyRate({ average, helpText, boxView }) {
  if (isNil(average)) {
    return null;
  }

  const labelClasses = classnames('mb-0', {
    'text-warning': average < THRESHOLD,
  });

  const id = 'average-daily-rate';

  return (
    <div className={boxView ? 'border rounded py-2 px-3' : ''}>
      {helpText && (
        <span className="mr-2">
          <InfoTooltip target={id}>{helpText}</InfoTooltip>
        </span>
      )}
      <Label className={labelClasses}>
        Onsite average daily rate
        <CurrencyFormat className="ml-4" value={average} text />
      </Label>
    </div>
  );
}

OnsiteAverageDailyRate.propTypes = {
  average: number,
  helpText: string,
  boxView: bool,
};

OnsiteAverageDailyRate.defaultProps = {
  average: null,
  helpText: '',
  boxView: false,
};

export default OnsiteAverageDailyRate;
